import { render, staticRenderFns } from "./FooterArrows.vue?vue&type=template&id=40f2f560"
import script from "./FooterArrows.vue?vue&type=script&lang=js"
export * from "./FooterArrows.vue?vue&type=script&lang=js"
import style0 from "./FooterArrows.vue?vue&type=style&index=0&id=40f2f560&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports